import Vue from "vue";
import Vuex from "vuex";
import { jwtToken } from "@/utils/tools.js";
import { baseRouter } from "../router/index";
import { hasPermission, filterAsyncRoutes } from "../router/filterRoute";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token")
      ? localStorage.getItem("token")
      : null,
    rightList: [],
    accountInfo: null, //用户token字段解析出来的信息
    bookApplyDetail: localStorage.getItem("bookApplyDetail")
      ? localStorage.getItem("bookApplyDetail")
      : {},
    routers: baseRouter, //存储生成的动态路由表
  },
  mutations: {
    setToken(state, token) {
      if (token && token !== "undefined") {
        state.token = token;
        window.localStorage.setItem("token", token);
      }
    },
    removeToken(state) {
      window.localStorage.removeItem("token");
      state.token = null;
      window.localStorage.removeItem("accountInfo");
      state.accountInfo = {}
    },
    setRightList(state) {
      state.rightList = jwtToken(state.token).authorities;
    },
    // 解析token获取全部用户信息
    setAccountInfo(state, val) {
      state.accountInfo = jwtToken(val);
      if (state.accountInfo["sub"]) {
        state.accountInfo["sub"] = JSON.parse(state.accountInfo.sub);
      }
      localStorage.setItem("accountInfo", state.accountInfo);
    },
    // 订购应用时保存用户选取的信息
    setBookApplyDetail(state, val) {
      state.bookApplyDetail = val;
      localStorage.setItem("bookApplyDetail", JSON.stringify(val));
    },
    // 支付成功后要清除订单信息（待定）
    removeBookApplyDetail(state) {
      state.bookApplyDetail = {};
      localStorage.removeItem("bookApplyDetail");
    },
    setRouters(state, routers) {
      state.routers = filterAsyncRoutes(routers, state.rightList);
      // 先过滤完权限路由再添加报错路由
      state.routers.push({
        path: "*",
        component: () => import("@/views/404.vue"),
      });
      // state.routers = baseRouter.concat(routers)
    },
  },
  actions: {
    // GenerateRoutes({commit},data){
    //     return new Promise(resolve => {
    //         const { permission } = data
    //         const permissions = permission //.split(',')
    //         const accessedRouters = dynamicRouter.filter(v => {
    //         //   if (permissions.indexOf('admin') >= 0) return true
    //           if (hasPermission(permissions, v)) {
    //             if (v.children && v.children.length > 0) {
    //                 v.children = filterAsyncRoutes(v.children,permissions)
    //             //   v.children = v.children.filter(child => {
    //             //     if (hasPermission(permissions, child)) {
    //             //       return child
    //             //     }
    //             //     return false
    //             //   })
    //               if (v.children.length === 0) { // 当children数组为空，即数组中的路由无权限被过滤掉
    //                 return false
    //               } else {
    //                 return v
    //               }
    //             } else {
    //               return false
    //             }
    //           }
    //           return false
    //         })
    //         commit('setRouters', accessedRouters)
    //         resolve()
    //     })
    // }
  },
});
